var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"desktop":"12","tablet":"8"}},[_c('dl',[_c('dt',[_vm._v("Login successful")]),_c('dt',[_vm._v("Your browser should be redirected soon")])])])])
}]

export { render, staticRenderFns }